<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-0">
    <div class="row">
      <upload-button-camera ref="cam" @changed="changed"></upload-button-camera>
    </div>
    <div class="row mt-1" v-for="userInput in el.UserInputs">
      <div class="col-12 px-0 px-1" v-show="$store.getUserPermissionLevel() >= el.UserLevel && isEnabled() == true && userInput.IsDeleted != true" style="padding-left:12px !important;">
        <a v-if="el.IsDeleted == true" target="_blank" @click="openUrl(el, userInput)" style="text-decoration: underline !important; cursor: pointer; text-decoration: line-through">{{userInput.Value}}</a>
        <a v-if="el.IsDeleted != true" target="_blank" @click="openUrl(el, userInput)" style="text-decoration: underline !important; cursor: pointer;">{{userInput.Value}}</a>
        <button type="button" class="btn btn-icon py-0" style="font-size:10px; border:0; padding-left:5px;cursor:pointer;text-decoration:underline;width:initial;height:initial" @click="deleteuserInputItem(el, userInput)"><i class="icon-cross2" style="font-size:12px;"></i></button>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "element-view-camera",
    components: {
      
    },
    props: {
      el: {
        type: Object,
        default: { Elements: [] }
      },
      date: {
        required: false,
        tyrrpe: String,
        default: null
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      assigned: {
        required: false,
        type: String,
        default: null
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },
      visible: {
        required: false,
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        files: [],
        storeUserName: ''
      };
    },
    methods: {
      deleteuserInputItem(el, userInput) {
        userInput.IsDeleted = true;
        Vue.set(el, "UserInputs", el.UserInputs);
        this.$forceUpdate();
        this.$emit("changed");
      },
      isEnabled() {
        return this.assigned == this.storeUserName || this.isshifttask == true || this.$store.getUserPermissionLevel() > 2;
      },
      changed(val, text, settings) {
        this.files.push({ filesettings: settings, internalurl: val, text: text, Property: {} })
        this.saveFilesToElement();
      },
      saveFilesToElement() {
        if (this.el.EnableMultiple == false) {
          // there can only be one child, so clear the others
          for (var i = 0; i < this.el.UserInputs.length; i++) {
            this.el.UserInputs[i].IsDeleted = true;
          }
          // Add one single file
          var newUserInput = {
            ElementType: this.el.ElementType,
            Settings: JSON.parse(JSON.stringify(this.files[0].filesettings)),
            IsAdded: true,
          }

          if (this.files[0].internalurl != null && this.files[0].internalurl != "") {
            newUserInput.Url = this.files[0].internalurl;
          }
          newUserInput.Id = -1;
          newUserInput.ParentId = this.el.Id;

          newUserInput.Value = this.files[0].text;

          this.el.UserInputs.push(newUserInput);

        }
        else {
          for (var i = 0; i < this.files.length; i++) {
            // Adding multiple files
            var newUserInput = {
              ElementType: this.el.ElementType,
              Settings: JSON.parse(JSON.stringify(this.files[i].filesettings)),
              IsAdded: true,
            }

            if (this.files[i].internalurl != null && this.files[i].internalurl != "") {
              newUserInput.Url = this.files[i].internalurl;
            }
            newUserInput.Id = -1;
            newUserInput.ParentId = this.el.Id;
            newUserInput.Value = this.files[i].text;
            this.el.UserInputs.push(newUserInput);

          }

          this.el.changed = true;
        }

        Vue.set(this.el, "UserInputs", this.el.UserInputs)

        this.$forceUpdate();

      },
      openUrl(el,val) {
        this.$emit('openUrl', el, val);
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        this.storeUserName = this.$store.getUsername();
        this.$refs.cam.setText(this.el.Text);
        if (this.el.Settings != null && this.el.Settings.Property != null && this.el.Settings.Property.ForceRecent == "true") {
          this.$refs.cam.forceRecency(true);
        }
        else {
          this.$refs.cam.forceRecency(false);
        }

        if (this.el.Settings != null && this.el.Settings.Property != null && this.el.Settings.Property.ForceCamera == "true") {
          this.$refs.cam.setCapture("camera");
          this.$refs.cam.setAccept("image/*");
        }
        else {
          this.$refs.cam.setCapture("");
        }
      }
    },
    computed: {
      elements: {
        get() {
          return this.el.Elements;
        }
      }
    },
    watch: {
     
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-viewing-elements/element-view-camera.vue